import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import styles from './AppointmentCardActions.module.sass'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import ModalOptions from '@jimmyboys/liita-ui/dist/components/ModalOptions'
import { useReload } from 'store'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import { useRecoilValue } from 'recoil'
import { expandedInboxWithSizeMediumState } from 'store/atoms'

import FuseHighlight from 'components/FuseHighlight/FuseHighlight'

const AppointmentCardActions = (props) => {
	const {
		data,
		setExpanded,
		showHistory,
		setShowHistory,
		showAppointmentHistory,
		setShowAppointmentHistory,
		...attributes
	} = props
	const { showDialog, i18n, screenSize } = useGlobal()
	const reload = useReload()
	const expandedInboxMedium = useRecoilValue(expandedInboxWithSizeMediumState)

	const options = [
		[
			{
				value: 'comment',
				text: i18n`Insert comment`,
				action: () => {
					showDialog(
						'CommentDialog',
						i18n`Insert comment`,
						{
							processId: data.processId,
							appointmentId: data?.id,
						},
						false,
						undefined,
						'center',
						'comment-dialog'
					)
						.then(() => {
							reload([
								`/clinical_processes/${data.processId}/appointments`,
							])
						})
						.catch(() => null)
				},
			},
			{
				value: 'ticket',
				text: i18n`Open associated ticket`,
				action: () => {
					showDialog(
						'TicketRequestDialog',
						i18n`Ticket Request Dialog Appointment ${data.id}`,
						{
							processId: data.processId,
							appointmentId: data.id,
						},
						false,
						undefined,
						'center',
						'request-ticket-dialog'
					)
						.then(() => {
							reload([
								`/clinical_processes/${data.processId}/tickets`,
								`/clinical_processes/${data.processId}/tasks`,
							])
						})
						.catch(() => null)
				},
			},
			{
				value: 'cancel',
				text: data.$cardLabels?.nullify,
				action: () => {
					showDialog(
						'NullifyAppointmentDialog',
						data.$cardLabels?.nullifyAppointment + ` #${data?.id}`,
						{
							processId: data.processId,
							appointmentId: data.id,
							totalRequisitions: data.requisitions?.length || 0,
							nullifyMessage: `${
								data.$cardLabels?.nullifyMessagePart1
							} ${data.requisitions?.length} ${
								data.requisitions?.length === 1
									? data.$cardLabels
											?.nullifyMessagePart2Singular
									: data.$cardLabels
											?.nullifyMessagePart2Plural
							}`,
							nullifyDerivedAppointments:
								data.$cardLabels?.nullifyMessagePart3,
						},
						false,
						undefined,
						'center',
						'nullify-appointment-dialog'
					)
						.then(() => {
							reload([
								`/clinical_processes/${data.processId}/appointments`,
							])
						})
						.catch(() => null)
				},
			},
		],
	]

	if (data?.history && data?.history?.length > 0) {
		options.unshift([
			{
				value: 'history',
				text: data.$cardLabels?.historyChanges,
				action: () => {
					setExpanded((value) => {
						if (value) {
							setShowHistory(!showHistory)
							return value
						} else {
							setShowHistory(true)
							return true
						}
					})
				},
			},
			{
				value: 'appointmentHistory',
				text: data.$cardLabels?.historyAppointment,
				action: () => {
					setExpanded((value) => {
						if (value) {
							setShowAppointmentHistory(!showAppointmentHistory)
							return value
						} else {
							setShowAppointmentHistory(true)
							return true
						}
					})
				},
			},
		])
	}

	const titles =
		options.length > 1 ? [i18n`See`, i18n`Actions`] : [i18n`Actions`]

	return (
		<div {...attributes} className={styles['card-actions']}>
			<VStack className={styles['actions-content']}>
				<ModalOptions
					className={styles['actions-modal']}
					titles={titles}
					groups={options}
					options={options}
					corner='straight'
					onSelect={(item) => {
						item && item.action && item.action()
					}}
				>
					<button className={styles['appointment-options']}>
						<Icon
							className={styles['more-icon']}
							width='32px'
							height='32px'
							name={'more'}
						/>
					</button>
				</ModalOptions>
				{!expandedInboxMedium && screenSize !== 'small' ? (
					<div className={styles['card-id-status']}>
						<h5
							className={
								styles[`card-id-status-${data?.status?.icon}`]
							}
						>
							{data?.status?.description}
						</h5>
						<small>
							#
							<FuseHighlight
								matchedWords={
									data.$textHighlight?.matchedIndexes?.['id']
								}
								text={data?.id}
							/>
						</small>
					</div>
				) : (
					''
				)}
			</VStack>
		</div>
	)
}

export default AppointmentCardActions
